exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "similarity .heading {\n  float: left; }\n\nsimilarity .action {\n  float: right; }\n\nsimilarity .content::after {\n  display: block;\n  clear: both;\n  content: \"\"; }\n\nsimilarity .editable {\n  padding: 0 10px;\n  float: left;\n  display: inline-block;\n  width: 48%;\n  height: 100%;\n  min-height: 700px;\n  border: 1px solid #f0f0f0; }\n\nsimilarity .left {\n  margin-right: 2%; }\n\nsimilarity .modal .content {\n  text-align: center; }\n  similarity .modal .content .title {\n    margin-bottom: 30px; }\n    similarity .modal .content .title .strong {\n      font-weight: bold; }\n    similarity .modal .content .title > div {\n      line-height: 30px;\n      display: flex; }\n    similarity .modal .content .title .label-left {\n      display: inline-block;\n      width: 50%;\n      text-align: right; }\n    similarity .modal .content .title .top {\n      letter-spacing: 4px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/app/components/page/similarity/similarity.scss
// module id = 1195
// module chunks = 3